import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { SIGNOUT, ROOT, SIGNUP, FORGETPASSWORD, MOSAIC, RESETPASSWORD, VERIFICATION, AUDITLOG, TERMSANDCONDITION, ALERTGRIDVIEW } from './../navigation/CONSTANTS';

import RootContainer from '../pages/Root/RootContainer';
// import MosaicContainer from '../pages/Mosaic/MosaicContainer'
import Signup from './Auth/Signup/Signup'
import Forgetpassword from './Auth/Forgetpassword/Forgetpassword'
// import NotFound from './NotFound';
import Login from './Auth/Login/Login'
import PrivateRoute from './Auth/PrivateRoute';
import { useAuth } from './Auth/ProvideAuth';
import ResetPassword from './Auth/ResetPassword/ResetPassword'
// import Verification from './Auth/Verification/Verification'
import Termscondition from '../pages/AboutMH/Termscondition';
// import AuditLog from '../pages/Configuration/AlertTemplate/AuditLog';
// import AlertMosaicView1 from '../pages/Alerts/AlertMosaicView1';
import withLazyLoad from '../HOC/withLazyLoad';
import withAccessAllowed from '../HOC/withAccessAllowed';

let getMenusAccess = JSON.parse(localStorage.getItem('user'));
let menusAccess = getMenusAccess?.MenuList;

const checkViewOperation = (menuName) => {
    const menu = menusAccess?.find((item) => item.Menuname === menuName);
    return menu ? menu.ViewOperation : false;
};

// const LazyTermscondition = withLazyLoad(() => import(/* webpackChunkName: "LazyTermsConditionPageComponent" */ '../pages/AboutMH/Termscondition'))

const LazyMosaicContainer = withLazyLoad(() => import(/* webpackChunkName: "LazyMosaicContainer" */'../pages/Mosaic/MosaicContainer'))

const LazyAlertMosaicView1 = withLazyLoad(() => import(/* webpackChunkName: "LazyAlertMosaicView1" */'../pages/Alerts/AlertMosaicView1'))

// const LazyForgetpassword = withLazyLoad(() => import(/* webpackChunkName: "LazyForgetpassword" */'./Auth/Forgetpassword/Forgetpassword'))

const LazyVerification = withLazyLoad(() => import(/* webpackChunkName: "LazyVerification" */'./Auth/Verification/Verification'))

// const LazyResetPassword = withLazyLoad(() => import(/* webpackChunkName: "LazyResetPassword" */'./Auth/ResetPassword/ResetPassword'))

const LazyAuditLog = withLazyLoad(() => import(/* webpackChunkName: "LazyAuditLog" */'../pages/Configuration/AlertTemplate/AuditLog'))

// const LazySignup = withLazyLoad(() => import(/* webpackChunkName: "LazySignUp" */'./Auth/Signup/Signup'))

const LazyNotFound = withLazyLoad(() => import(/* webpackChunkName: "LazyNotFound" */'./NotFound'))

// const LazyLogin = withLazyLoad(() => import(/* webpackChunkName: "LazyLogin" */'./Auth/Login/Login'))

const ProtectedAlertMosaic = withAccessAllowed(LazyAlertMosaicView1, checkViewOperation('Alerts'))

const ProtectedMosaicContainer = withAccessAllowed(LazyMosaicContainer, checkViewOperation('Cameras'))

export const RouterConfig = ({ match }) => {
    let auth = useAuth();
    
    return (
        <Switch>
            {/* List all public routes here */}
            <Route path="/login">
                <Login />
            </Route>
            <Route path={SIGNUP}>
                <Signup />
            </Route>
            <Route path={FORGETPASSWORD}>
                <Forgetpassword />
            </Route>
            <Route path={VERIFICATION}>
                <LazyVerification />
            </Route>
            <Route path={RESETPASSWORD}>
                <ResetPassword />
            </Route>

            <Route path={AUDITLOG}>
                <LazyAuditLog />
            </Route>

            {/* Dispay T&C page after login (Excluding sidebar and header) */}
            {/* <Route path={TERMSANDCONDITION}>
                <Termscondition />
            </Route> */}
             <PrivateRoute path={TERMSANDCONDITION}>
                <Termscondition />
            </PrivateRoute>


            <Route path={SIGNOUT} component={() => auth.signout()} />

            {/* List all private/auth routes here */}
            <PrivateRoute path={MOSAIC}>
                <ProtectedMosaicContainer />
            </PrivateRoute>

            <PrivateRoute path={ALERTGRIDVIEW}>
                <ProtectedAlertMosaic />
            </PrivateRoute>

            <PrivateRoute path={ROOT}>
                <RootContainer />
            </PrivateRoute>

            {/* List a generic 404-Not Found route here */}
            <Route path="*">
                <LazyNotFound />
            </Route>

        </Switch>
    )
}
